/**
 * Central API configuration for utilities.mw
 * Runtime: when the SPA is on http://localhost (port 80), API uses same-origin /api (nginx proxy).
 */

function resolveBackendUrl() {
  if (typeof window !== 'undefined' && window.location) {
    const { hostname, port, protocol, origin } = window.location;
    const effectivePort = port || (protocol === 'https:' ? '443' : '80');
    // SPA + API on one host (nginx, Docker, or serve on :80)
    if (
      effectivePort === '80' ||
      effectivePort === '443' ||
      port === ''
    ) {
      return origin;
    }
    // CRA dev server
    if (port === '3000' || port === '3001') {
      if (hostname !== 'localhost' && hostname !== '127.0.0.1') {
        return `${protocol}//${hostname}:8001`;
      }
      return 'http://localhost:8001';
    }
  }

  const fromEnv = process.env.REACT_APP_BACKEND_URL?.trim().replace(/\/$/, '');
  if (fromEnv) return fromEnv;

  if (process.env.NODE_ENV !== 'production') {
    return 'http://localhost:8001';
  }

  return undefined;
}

const backendUrl = resolveBackendUrl();

if (process.env.NODE_ENV === 'production' && !backendUrl && typeof window === 'undefined') {
  throw new Error(
    'REACT_APP_BACKEND_URL is required for production builds. ' +
    'Example: REACT_APP_BACKEND_URL=https://utilities.mw npm run build'
  );
}

export const BACKEND_URL = backendUrl || 'http://localhost:8001';
export const API_URL = `${BACKEND_URL}/api`;
export const SITE_URL =
  process.env.REACT_APP_SITE_URL || 'https://utilities.mw';
export const SITE_NAME = process.env.REACT_APP_SITE_NAME || 'Utilities MW';
export const CONTACT_EMAIL =
  process.env.REACT_APP_CONTACT_EMAIL || 'support@utilities.mw';

/** WhatsApp Business number for user support (E.164, no leading +/spaces for wa.me). */
export const SUPPORT_WHATSAPP_NUMBER =
  process.env.REACT_APP_SUPPORT_WHATSAPP_NUMBER || '265994123079';
export const SUPPORT_WHATSAPP_URL = `https://wa.me/${SUPPORT_WHATSAPP_NUMBER}`;

/**
 * Global OTP timer (seconds) — fallback only. The backend is the source of
 * truth via `expires_in_seconds` in OTP responses (OTP_TIMEOUT_MINUTES).
 */
export const OTP_TIMEOUT_SECONDS = 600;

/**
 * Global payment session timer (seconds) — fallback only. The backend returns
 * `payment_timeout_seconds` from PAYMENT_TIMEOUT_MINUTES.
 */
export const PAYMENT_TIMEOUT_SECONDS = 600;
export const PAYMENT_POLL_TIMEOUT_MS = PAYMENT_TIMEOUT_SECONDS * 1000;

export const ALLOW_DEV_OTP =
  process.env.REACT_APP_ALLOW_DEV_OTP === 'true' ||
  process.env.NODE_ENV !== 'production';

export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID?.trim() || '';

/** Call before API requests if the page may have been opened on a new port (rare). */
export function getApiUrl() {
  return `${resolveBackendUrl() || BACKEND_URL}/api`;
}
